import concat from 'lodash/concat';
import uniqBy from 'lodash/uniqBy';
import { HomeState } from '../States';
import { HomeTypes } from '../Types';

export default function(state = HomeState, action) {
  switch (action.type) {
    case HomeTypes.IS_API_PROGRESS:
      return {
        ...state,
        isAPIProgress: action.payload,
      };
    case HomeTypes.IS_JOB_APPLICATION_API_IN_PROGRESS:
      return {
        ...state,
        isJAAPIProgress: action.payload,
      };
    case HomeTypes.SET_JOB_APPLICATIONS:
      return {
        ...state,
        jobApplications: action.payload || [],
      };
    case HomeTypes.CONCAT_JOBS:
      return {
        ...state,
        jobs: uniqBy(concat(state.jobs, action.payload.jobs), 'jobId'),
        offset: action.payload.offset,
      };

    case HomeTypes.UNSET_SELECTED_JOB:
      return {
        ...state,
        selectedJob: {},
      };
    case HomeTypes.SET_SELECTED_JOB:
      return {
        ...state,
        selectedJob: action.payload.selectedJob,
      };
    case HomeTypes.TOGGLE_SALARY_RANGE:
      return {
        ...state,
        isSalarySliderVisible: action.payload,
      };
    case HomeTypes.SALARY_SELECTED:
      return {
        ...state,
        selectedSalary: action.payload,
      };
    case HomeTypes.RESET_FEED:
      return {
        ...state,
        jobs: [],
        page: 0,
      };

    case HomeTypes.TOGGLE_CITY:
      return {
        ...state,
        isCitySelectionVisible: action.payload,
      };

    case HomeTypes.CITY_SELECTED:
      return {
        ...state,
        selectedCity: action.payload,
      };

    case HomeTypes.TOGGLE_LOCALITY:
      return {
        ...state,
        isLocalityVisible: action.payload,
      };
    case HomeTypes.LOCALITY_SELECTED:
      return {
        ...state,
        selectedLocalities: action.payload,
      };

    case HomeTypes.TOGGLE_JOB_ROLE:
      return {
        ...state,
        isJobRoleSelectionVisible: action.payload,
      };

    case HomeTypes.ROLES_SELECTED:
      return {
        ...state,
        selectedJobRoles: action.payload,
      };

    case HomeTypes.SELECT_JOB_APPLICATION:
      return {
        ...state,
        selectedJobApplication: action.payload,
      };

    case HomeTypes.SET_TRACK_INFO:
      return {
        ...state,
        trackInfo: action.payload || [],
      };

    case HomeTypes.LOADING_USER_SETTING:
      return {
        ...state,
        isLoadingUserSettings: action.payload,
      };

    case HomeTypes.SET_USER_SETTINGS:
      return {
        ...state,
        userSettings: action.payload,
      };
    case HomeTypes.TOGGLE_WORK_AREA:
      return {
        ...state,
        isWorkAreaVisible: action.payload,
      };
    case HomeTypes.TOGGLE_LOGIN:
      return {
        ...state,
        isLoginPopupVisible: action.payload,
      };
    case HomeTypes.TOGGLE_OTP:
      return {
        ...state,
        isOtpPopupVisible: action.payload,
      };
    case HomeTypes.SET_MITRA_CALL_FLOW_STATE:
      return {
        ...state,
        callMitraFlowState: action.payload,
      };
    case HomeTypes.SET_CALLING_THROUGH_APPLY_FLOW:
      return {
        ...state,
        callingThroughApplyFlow: action.payload,
      };
    case HomeTypes.SET_SELECTED_JOB_FOR_CALL:
      return {
        ...state,
        selectedJobForCall: action.payload,
      };
    default:
      return state;
  }
}
